import React, { Component } from 'react'
import {
  Input,
  Button,
  Icon,
  Affix,
  Menu,
  Row,
  DatePicker,
  message,
  Modal,
  Spin,
  Select,
} from 'antd'
import { observer, inject } from 'mobx-react'
import { action } from 'mobx'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import queryString from 'query-string'

const RangePicker = DatePicker.RangePicker
const { Search } = Input

@inject("auth") @observer
class DataHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dayKey: "-1",
      exportModalShowed: false,
      searchType: 'groupName'
    }
  }

  //搜索框更新
  @action
  changeSearch = (e) => {
    const keywords = e.target.value
    this.setState({
      inputSearch: keywords,
    })
  }

  searchData = () => {
    const { history, match } = this.props
    const { searchType } = this.state
    history.push({
      pathname: `${match.url}`,
      search: queryString.stringify({
        [`${searchType}`]: this.state.inputSearch,
      })
    })

  }

  searchTypeChange = (e) => {
    const { list: { queryMap } } = this.props.store
    const { searchType } = this.state
    const kySearchInput = document.querySelector('#ky-search-input')
    this.setState({
      searchType: e,
      inputSearch: ''
    })
    queryMap[this.state.searchType] = ''
    this.refs.kyInput.input.focus()
    kySearchInput.setAttribute('placeholder', searchType === 'groupName' ? '请输入数据来源搜索' : '请输入家系名搜索')
  }

  render() {
    const { inputSearch } = this.state
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          <div className="search-bar">
            <div className="pull-left">
              <Select defaultValue="groupName" onChange={this.searchTypeChange}>
                <Select.Option value="groupName">家系</Select.Option>
                <Select.Option value="username">数据来源</Select.Option>
              </Select>
              <Search
                id="ky-search-input"
                value={inputSearch}
                placeholder="请输入家系名搜索"
                size="large"
                onChange={this.changeSearch}
                onSearch={this.searchData}
                ref="kyInput"
              />
            </div>
          </div>
          {this.renderDayMenu()}
        </div>
      </Affix>
    )
  }

  dateChange = (dateValue, dateString) => {
    const { list: { updateQueryMap } } = this.props.store
    updateQueryMap({ start: dateString[0], end: dateString[1] })
    this.setState({     //日期回显
      dateValue: dateValue
    })
  }

  dateChangeOk = () => {
    this.setState({  // 重置近几天的选项
      dayKey: "-1",
    })
    let {
      list: { filterData, queryMap }
    } = this.props.store

    filterData({ end: moment(queryMap.end, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
  }

  onDayChange = (e) => {
    let startDay = null
    const {
      list: { filterData }
    } = this.props.store

    this.setState({  //设置近几天同时重置日期选择
      dayKey: e.key,
      dateValue: null,
    })
    if (e.key !== "-1") {
      startDay = moment(moment() - e.key * 1000 * 3600 * 24).format("YYYY-MM-DD")
    }

    filterData({ start: startDay, end: null })
  }

  onDataChange = (e, type) => {
    this.props.store.list.tableData = []

    switch (type) {
      case "belong": this.onBelongChange(e)
        break
      case "app": this.onAppChange(e)
        break
      case "day": this.onDayChange(e)
        break
      default: this.dateChangeOk()
    }
  }

  exportPointDiagram = () => {
    const { exportPointDiagram, selectedRowKeys } = this.props.store
    if (!selectedRowKeys.length) {
      message.error('请选择家系')
      return
    }
    this.setState({
      exportModalShowed: true
    })
    exportPointDiagram(selectedRowKeys)
      .then(
        res => {
          const exportDataUrl = res.url
          this.setState({
            exportModalShowed: false
          })
          if (document.getElementById('export-a-tag')) document.getElementById('export-a-tag').outerHTML = ""
          let a = document.createElement('iframe')
          a.setAttribute('src', exportDataUrl)
          a.setAttribute('id', 'export-a-tag')
          a.setAttribute('style', 'display:none')
          //防止反复添加
          if (!document.getElementById('export-a-tag')) document.body.appendChild(a)
        },
        err => {
          message.error('导出失败，请您重试！')
          this.setState({
            exportModalShowed: false
          })
        }
      )
  }

  renderDayMenu = () => {
    return (
      <Row
        type="flex"
        justify="start"
        align="middle"
        className="search-time-bar affix-line"
      >
        <Row
          type='flex'
          align='middle'
        >
          <Menu className="menu-day" onClick={e => this.onDataChange(e, "day")}
            selectedKeys={[this.state.dayKey]}
            mode="horizontal"
            key="menu_date_0">
            <Menu.Item key="-1">
              <Icon type="calendar" />全部
          </Menu.Item>
            <Menu.Item key="0">今天</Menu.Item>
            <Menu.Item key="3">三天内</Menu.Item>
            <Menu.Item key="7">七天内</Menu.Item>
            <Menu.Item key="15">十五天内</Menu.Item>
            <Menu.Item key="30">三十天内</Menu.Item>
          </Menu>
          <RangePicker
            ranges={{
              "今天": [moment(), moment()],
              "本月": [moment().startOf("month"), moment()]
            }}
            showTime
            value={this.state.dateValue}
            onChange={this.dateChange}
            onOk={this.onDataChange}
            disabledDate={this.disabledDate}
          />
        </Row>
        <Row>
          <Button
            type="primary"
            size="default"
            className="export-btn"
            onClick={this.exportPointDiagram}
          >
            <Icon type="download" />导出点图
          </Button>
        </Row>
        <Modal
          className="statistics-export-modal"
          width={230}
          visible={this.state.exportModalShowed}
          footer={null}
        >
          <div className="export-loading"><Spin size="large" /></div>
          <div className="export-tips">正在导出中，请稍等。。。</div>
        </Modal>
      </Row>
    )
  }
}
export default withRouter(DataHeader)



// WEBPACK FOOTER //
// ./src/app/pages/research/pgs/data_manage/containers/DataHeader.js